import config from '../config'
import APIV2 from './v2'
import APIV1 from './v1'

class API {
  get api () {
    if (config.apiVersion === '2') {
      return APIV2
    }

    if (config.apiVersion === '1') {
      return APIV1
    }

    throw new Error(`Api version ${config.apiVersion} is not supported`)
  }

  get dimension () {
    return this.api.dimension
  }

  get measure () {
    return this.api.measure
  }

  get data () {
    return this.api.data
  }

  get version () {
    return this.api.version
  }

  get target () {
    return this.api.target
  }
}

export default new API()



// WEBPACK FOOTER //
// ./node_modules/macarons-graphs-front/src/api/index.js